export const LOGOUT_MODAL = 'LOGOUT_MODAL';

export const MAP_TOOLS_INFO_POPUP = 'MAP_TOOLS_INFO_POPUP';
export const GEOCONFIRMED_OBJECT_DETAILS_POPUP =
  'GEOCONFIRMED_OBJECT_DETAILS_POPUP';

export const CREATE_QUICK_ENTITY_MODAL = 'CREATE_QUICK_ENTITY_MODAL';
export const ENTITY_PREVIEW_MODAL = 'ENTITY_PREVIEW_MODAL';
export const ENTITY_DETAILS_MODAL = 'ENTITY_DETAILS_MODAL';

export const IMAGERY_UPLOAD_MODAL = 'IMAGERY_UPLOAD_MODAL';
export const SHARE_MODAL = 'SHARE_MODAL';
export const CREATE_DRAW_FEATURE_MODAL = 'CREATE_DRAW_FEATURE_MODAL';
